import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { getImageUrl } from '../utils/imageHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const Sidebar = () => {
  const [advertisements, setAdvertisements] = useState([]);

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  const fetchAdvertisements = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/advertisements`);
      // Filter for sidebar position ads
      const sidebarAds = response.data.filter(ad => ad.position === 'sidebar');
      setAdvertisements(sidebarAds);
    } catch (error) {
      console.error('Failed to fetch advertisements:', error);
    }
  };

  return (
    <aside className="space-y-6">
      {/* E-Paper Subscription */}
      <Card className="border-gray-200">
        <CardHeader>
          <CardTitle className="text-xl">Subscribe to E-Paper</CardTitle>
          <CardDescription>Get access to daily digital newspaper and archives</CardDescription>
        </CardHeader>
        <CardContent>
          <a href="/subscribe">
            <Button className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2">
              View Plans
            </Button>
          </a>
        </CardContent>
      </Card>

      {/* Advertisements */}
      {advertisements.length > 0 && advertisements.map((ad) => (
        <Card key={ad.id} className="border-gray-200 overflow-hidden">
          <CardContent className="p-0">
            {ad.link_url ? (
              <a href={ad.link_url} target="_blank" rel="noopener noreferrer">
                <img
                  src={getImageUrl(ad.image_url)}
                  alt={ad.title}
                  className="w-full h-auto object-contain hover:opacity-90 transition-opacity cursor-pointer"
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=400&fit=crop';
                  }}
                />
              </a>
            ) : (
              <img
                src={getImageUrl(ad.image_url)}
                alt={ad.title}
                className="w-full h-auto object-contain"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=400&fit=crop';
                }}
              />
            )}
          </CardContent>
        </Card>
      ))}

      {/* Photo Archives Link */}
      <Card className="border-gray-200 bg-gradient-to-br from-gray-50 to-white">
        <CardHeader>
          <CardTitle className="text-xl">ছবির সংগ্রহশালা</CardTitle>
          <CardDescription>Photo Archives</CardDescription>
        </CardHeader>
        <CardContent>
          <a href="/photo-archives">
            <Button className="w-full bg-gray-900 hover:bg-gray-800 text-white font-semibold py-2">
              View Gallery
            </Button>
          </a>
        </CardContent>
      </Card>

      {/* Citizen Reporter CTA */}
      <Card className="border-gray-200 bg-gradient-to-br from-red-50 to-white">
        <CardHeader>
          <CardTitle className="text-xl">নাগরিক প্রতিবেদক</CardTitle>
          <CardDescription>Citizen Reporter</CardDescription>
        </CardHeader>
        <CardContent>
          <a href="/citizen-reporter">
            <Button variant="outline" className="w-full border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-semibold py-2">
              Submit Your Story
            </Button>
          </a>
        </CardContent>
      </Card>
    </aside>
  );
};

export default Sidebar;